




















































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import * as Constants from "@/Constants";
import {BudgetAllocation} from "@/modules/budget/BudgetAllocation";
import {Budget} from "@/modules/budget/Budget";
import Tag from "@/components/miscellaneous/Tag.vue";
import {Getter} from "vuex-class";
import moment from "moment";
import _ from "lodash";
import NotificationSocleRepository from "@/repositories/NotificationRepository";
import NotificationRepository from "@/repositories/request/NotificationRepository";
import {Notification} from "@/modules/request/Notification";

const components = {
    Tag
};

@Component({components})
export default class NotificationDetails extends Vue {
    @Prop({default: null}) private notification!: Notification;
    @Prop() private typeNotification!: string;

    @Getter("getBudgetAllocations") protected budgetAllocations!: (ownerUuid: string) => void;
    @Getter("getUserDepartment") protected userDepartment!: string;
    @Getter("getBudgets") protected budgets!: Budget[];

    private notificationsTabs = Constants.notificationsTabs;
    private requestStatus = Constants.requestStatus;
    private notificationChannels: { [channel: string]: string } = Constants.notificationChannels;
    private loadingNotification: boolean = false;
    private localNotification: Notification = {} as Notification;
    private notificationAllDetails: string = Constants.notificationAllDetails.allNotificationsDetails;
    private notificationAllStatus: { [key: string]: string } = Constants.notficationStatusDetails;

    @Watch("notification", { immediate: true, deep: true })
    private onNotificationChange(newVal: Notification) {
        this.localNotification = _.cloneDeep(newVal);
    }

    private saveNotification(): void {
        this.loadingNotification = true;
        const notificationData = {
            uuid: this.localNotification.uuid,
            isActive: this.localNotification.isActive
        };
        const translationKey = notificationData.isActive ? "saveNotificationActivate" : "saveNotificationDeactivate";

        if (this.typeNotification === this.notificationsTabs.request) {
            NotificationRepository.save(notificationData).then(() => {
                this.loadingNotification = false;
                this.$message({
                    message: _.invoke(this.$options.filters, "trans", translationKey),
                    type: "success"
                });
                this.$emit("notification-saved");
            });
        } else if (this.typeNotification === this.notificationsTabs.socle) {
            NotificationSocleRepository.save(notificationData).then(() => {
                this.loadingNotification = false;
                this.$message({
                    message: _.invoke(this.$options.filters, "trans", translationKey),
                    type: "success"
                });
                this.$emit("notification-saved");
            });
        }
    }

    private get optionsAllocations(): Array<{ key: string, label: string, year: string }> {
        const optionsResult = [
            {
                key: "",
                label: _.invoke(this.$options.filters, "trans", "allBudgets"),
                year: "",
            }];

        const result = _.concat(
            optionsResult,
            _.map(this.budgetAllocations, (budgetAllocation: BudgetAllocation, key) => {
                const budgetFound = _.find(this.budgets, (budget) => {
                    return budget.uuid === budgetAllocation.budget.uuid;
                });

                const year = moment(_.get(budgetFound, "beginDate", ""), "YYYYMMDD").format("YYYY");
                return {key: budgetAllocation.uuid, label: budgetAllocation.label, year};
            })
        );

        return _.sortBy(result, (line) => {
            return !line.year + line.year + line.label;
        });
    }

    private editNotification(notification: Notification): void {
        if (!notification || !notification.uuid) {
            this.$emit("edit-notification", null);
            return;
        }
        this.$router.push({
            name: `notifications_${this.typeNotification}_edit`,
            params: {
                uuid: notification.uuid,
                module: this.typeNotification
            }
        });
    }

    private deleteNotification(uuid: string): void {
        this.$emit("delete-notification", uuid);
    }
}
